import {useCallback, useRef} from 'react';
import {serializeForComparison} from './compareValues';

const useUnsavedFormState = fields => {
  const names = Object.keys(fields);
  const values = names.reduce((acc, name) => {
    acc[name] = fields[name][0];
    return acc;
  }, {});

  const latestValuesRef = useRef(values);
  latestValuesRef.current = values;

  const fieldsRef = useRef(fields);
  fieldsRef.current = fields;

  const savedRawRef = useRef(values);
  const savedValuesRef = useRef(serializeForComparison(values));

  const hasUnsavedChanges =
    savedValuesRef.current !== serializeForComparison(values);

  const markSaved = useCallback(() => {
    savedRawRef.current = latestValuesRef.current;
    savedValuesRef.current = serializeForComparison(latestValuesRef.current);
  }, []);

  const revertUnsavedChanges = useCallback(() => {
    const saved = savedRawRef.current || {};
    Object.keys(fieldsRef.current).forEach(name => {
      const setter = fieldsRef.current[name][1];
      if (typeof setter === 'function') {
        setter(saved[name]);
      }
    });
  }, []);

  return {hasUnsavedChanges, markSaved, revertUnsavedChanges};
};

export default useUnsavedFormState;
